import request from '@/utils/wxfwh-request'

export function sendSms(data) {
  return request.post('/wx-fwh/send-sms', data)
}

export function bindMember(data) {
  return request.post('/wx-fwh/bind-member', data)
}

export function wxfwhLogin(data) {
  return request.post('/wx-fwh/wx-login', data)
}

export function wxfwhGetLoginInfo(data) {
  return request.post('/wx-fwh/get-login-info', data)
}

export function wxfwhGetMemberInfo(data) {
  return request.post('/wx-fwh/member-info', data)
}

export function getInvoiceList(data) {
  return request.post('/invoice/list', data)
}

export function addInvoice(data) {
  return request.post('/invoice/add', data)
}

export function modifyInvoice(data) {
  return request.post('/invoice/modify', data)
}

export function deleteInvoice(data) {
  return request.post('/invoice/delete', data)
}

export function getMemberInvoiceList(data) {
  return request.post('/member-invoice/list', data)
}

export function addMemberInvoice(data) {
  return request.post('/member-invoice/add', data)
}

export function modifyMemberInvoice(data) {
  return request.post('/member-invoice/modify', data)
}

export function deleteMemberInvoice(data) {
  return request.post('/member-invoice/delete', data)
}

export function setDefaultMemberInvoice(data) {
  return request.post('/member-invoice/set-default', data)
}

export function listByMemberOfSellOrder(data) {
  return request.post('/sell-order/list-by-member', data)
}

export function getSellOrderList(data) {
  return request.post('/sell-order/list', data)
}

export function wxAuth(data) {
  return request.get(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${data.appid}&redirect_uri=${data.redirect_uri}&response_type=code&scope=SCOPE&state=STATE#wechat_redirect`)
}



// WEBPACK FOOTER //
// ./src/api/wx-fwh.js